import { Box, Fade } from '@material-ui/core';
import { ArrowUpward, ArrowDownward, Cancel } from '@material-ui/icons';

interface ISortProps {
  sortDirection: 'asc' | 'desc' | undefined
  handleSortChange: () => void,
  isHovered: boolean,
  handleClearSort?: () => void
}
const Sort = ({ sortDirection, handleSortChange, isHovered = false, handleClearSort }: ISortProps) => {
  return (
    <Fade in={isHovered || !!sortDirection} >
      <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          right: 8
        }}>
        {sortDirection === 'asc' || sortDirection === undefined ? (
          <ArrowUpward fontSize="small" onClick={handleSortChange} />
        ) : (
          <ArrowDownward fontSize="small" onClick={handleSortChange} />
        )}
        {!!sortDirection &&  <Cancel  fontSize='small' style={{marginLeft: 5}} onClick={handleClearSort}/> }
      </Box>
    </Fade>
  );
};

export default Sort;